import {SessionState} from "../Session/types";
import {ConfigApi, MoneyApi} from "../Api/types";
import {CartState} from "./types";
import ItemHelper from "../Menu/services/Item/ItemHelper";

class CartUtils {
    static getCartNumber(session: SessionState) {
        if (session.order_type === "ROOM_SERVICE") return session.room_number;
        if (session.order_type === "DINE_IN") return session.table_number;
        return undefined;
    }

    static isPickDateEnabled(config?: ConfigApi, session?: SessionState) {
        if (!config?.ordering.pick_date) return false;
        if (session && session.order_type && session.order_type === "DINE_IN") return false;
        return true;
    }

    static isTipEnabled(config?: ConfigApi) {
        if (!config?.ordering.tip) return false;
        return true;
    }

    static isBox(item: any) {
        return item.name.includes("opak");
    }

    static getBoxPrice(cart: CartState, items: any) {
        let boxPrice = 0;
        cart.items.forEach(cartItem => {
            const cartItemQuantity = cartItem.quantity;
            const discountPercent = cartItem.discount_money ? (cartItem.total_money.amount + cartItem.discount_money.amount) / cartItem.discount_money.amount : 0;
            let orderItemBoxPrice = 0;
            cartItem.modifier_groups.forEach((mg: any) => {
                mg.selected_items.forEach((si: any) => {
                    const siItem = ItemHelper.getItem(items, si.item_id);
                    if (this.isBox(siItem)) {
                        orderItemBoxPrice += si.total_money.amount * cartItemQuantity;
                    }
                })
            })
            boxPrice += orderItemBoxPrice - (orderItemBoxPrice * discountPercent / 100);
        });
        return boxPrice;
    }

    static addMoney(money1: MoneyApi, money2: MoneyApi) {
        if (!money1) return money2;
        if (!money2) return money1;
        return {
            amount: money1.amount + money2.amount,
            currency: money1.currency
        } as MoneyApi
    }

    static getTipItemIds(cartPromotions: any[]) {
        const tipPromotions = cartPromotions.filter((x: any) => (x.type === "TIP_MANUALLY" || x.type === "TIP"));
        return tipPromotions.flatMap((x: any) => x.items).map((x: any) => x.order_item_uid)
    }

    static getItemsWithoutTips(items: any[], cartPromotions: any[]) {
        const tipItemIds = this.getTipItemIds(cartPromotions);
        return items.filter((x: any) => !tipItemIds.includes(x.uid));
    }

    static getCreditValue(cart: any) {
        const cashbackPromotion = cart.promotions.filter((x:any) => x.type === "CREDIT")[0];
        return cashbackPromotion && cashbackPromotion.value_money ? cashbackPromotion.value_money.amount : 0;
    }

}

export default CartUtils;
